<script setup>
setPageTitle(PageMeta.Invoices.service.title)
definePage({ meta: PageMeta.Invoices.service.meta })
import { ServiceType } from '@/@vxapp/@Enums/ServiceType'
import InvoicesServicePage from '@/views/Previews/Invoices/InvoicesServicePage.vue'

/** **/
</script>

<template>
  <div
    class="preview-service-wrapper"
    data-testid="service-page-root"
    :data-service-type="ServiceType.Invoices.Name"
  >
    <InvoicesServicePage />
  </div>
</template>
